import {TranslateService} from '@ngx-translate/core';

import {ChartUtils} from '../../+postpayroll/check/key-metrics/charts/chart.utils';
import {BasicColumn} from '../../+postpayroll/check/key-metrics/charts/column/basic-column';
import {Chart} from '../../+postpayroll/check/key-metrics/key-metrics.interfaces';
import {LocalizationService} from '../../shared/localization/localization.service';
import {DashboardBox, ResponseChartBox} from '../dashboard.interfaces';

import {DashboardChartUtils} from './dashboard-chart.utils';
import {Scss} from '../../shared/utils/scss';

export class TurnOverChart extends BasicColumn {
  constructor(chartBox: ResponseChartBox,
              translate: TranslateService,
              localization: LocalizationService,
              isAvg: boolean) {
    const params = chartBox.params;
    const chart: Chart = ChartUtils.getEmptyChart();

    Object.keys(params).forEach((key: string) => {
      if (!params[key].length) {
        chart.data.push({
          category: null,
          name: key,
          value: null
        });
      }

      chart.data.push({
        category: '',
        name: key,
        value: params[key][0].value,
        metadata: params[key][0].link
      });
    });
    chart.type = chartBox.cardType;

    super(chart, translate, localization, isAvg);

    this.xAxis[0].data = DashboardChartUtils.formatCategories(this.xAxis[0].data, translate);
    this.xAxis[0].axisLabel = DashboardChartUtils.getAxisOptions();
    this.yAxis[0].axisLabel = {
      formatter: (value) => `${(value * 100).toFixed(2)}%`
    };
    this.grid = DashboardChartUtils.getGridOptions();
    this.tooltip.trigger = 'axis';
    this.tooltip.formatter = (values: any) => {
      values = values[0];
      return `${
        values.marker
      } ${
        this.translate.instant(values.name)
      }: ${
        this.localization.localizeNumber(values.value, 'PERCENT_2_DIGIT')
      }`;
    };
    this.animation = true;

    DashboardChartUtils.setLinks(this.series, this.chart, this.categories);
    this.tooltip.position = DashboardChartUtils.getTooltipPositionFunc(<DashboardBox>chartBox);

    this.series.forEach((serie, index) => {
      serie.itemStyle = {
        normal: {
          barBorderRadius: [5,5,0,0],
        }
      }
    });
    const chartColor = Scss.variable('chart-turnover');
    this.color = [chartColor];
  }

  public sortCategories(array: string[]): string[] {
    return DashboardChartUtils.monthSort(array);
  }
}
